var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"flat":""}},[_c('v-toolbar-title',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){return _vm.$emit('back')}}},[_c('v-icon',[_vm._v("arrow_left")]),_vm._v(" Templates")],1)],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }